import { render, staticRenderFns } from "./taskscenter.vue?vue&type=template&id=70cde568&scoped=true"
import script from "./taskscenter.vue?vue&type=script&lang=js"
export * from "./taskscenter.vue?vue&type=script&lang=js"
import style0 from "./taskscenter.vue?vue&type=style&index=0&id=70cde568&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cde568",
  null
  
)

export default component.exports